import PropTypes from "prop-types";
import { Tooltip } from "@material-tailwind/react";
import { FiInfo } from "react-icons/fi";

export const shortenResourceName = (name) => {
  const characters = Array.from(name || "");
  return characters.length > 20 ? `${characters.slice(0, 19).join("")}…` : name || "";
};

const ResourceFilename = ({ name, originalName, className = "" }) => {
  const fullName = originalName || name || "";

  return (
    <Tooltip
      content={<span dir="auto" className="block break-all">{fullName}</span>}
      interactive
      className="max-w-[min(20rem,calc(100vw-2rem))]"
    >
      <button
        type="button"
        aria-label={fullName}
        className={`inline-flex min-h-11 w-full min-w-0 max-w-full items-center gap-2 rounded-lg px-1 text-start focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 ${className}`}
      >
        <span dir="auto" className="min-w-0 truncate">{shortenResourceName(name)}</span>
        <FiInfo aria-hidden="true" data-testid="resource-name-info" className="shrink-0 text-gray-500 dark:text-gray-400" />
      </button>
    </Tooltip>
  );
};

ResourceFilename.propTypes = {
  name: PropTypes.string,
  originalName: PropTypes.string,
  className: PropTypes.string,
};

export default ResourceFilename;
